import React from 'react'
import { theme } from '../../theme'

const BigNumbers = ({ image, label, strongLabel, number }) => {
  return (
    <div
      style={{ height: '100px', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '0 20px' }}
    >
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '80px' }}>
        <img src={image} alt="" />
      </div>
      <div
        style={{
          flex: 1,
          padding: '0 10px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: '150px',
        }}
      >
        <p style={{ fontSize: 16, color: '#000', textAlign: 'left' }}>
          {label} <strong style={{ fontWeight: 800, color: '#000000' }}>{strongLabel}</strong>
        </p>
      </div>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', width: '30px' }}>
        <p style={{ color: theme.colors.primary, fontSize: 42, fontWeight: 800 }}>{number}</p>
      </div>
    </div>
  )
}

export default BigNumbers
